/**
 * 要素のクリックイベントを管理するクラス
 */
export class OnClickManager {
    // アクション定義を格納するオブジェクト
    static #actions = {
        youtubemodal: (isOn, element) => {
            if (isOn) {
                element.querySelector(".Modal__inner").innerHTML =
                    element.querySelector("template.content").innerHTML;
            } else {
                element.querySelector(".Modal__inner").innerHTML = "";
            }
        },
        // スクロールロックのアクションを追加
        "scroll-lock": (isOn, element) => {
            const body = document.body;
            if (isOn) {
                body.style.overflow = "clip";
            } else {
                body.style.overflow = "";
            }
        },
    };

    // イベントリスナーを保持するための Map
    static #eventListeners = new Map();

    /**
     * アクションを追加する
     * @param {string} name - アクション名
     * @param {Function} handler - アクションハンドラー
     */
    static addAction(name, handler) {
        this.#actions[name] = handler;
    }

    /**
     * 指定された要素にクリックイベントを設定する
     * @param {string} selector - クリックイベントを設定する要素のセレクター
     */
    static init(selector = ".onClick") {
        const elements = document.querySelectorAll(selector);
        elements.forEach((element) => {
            const handler = this.#createClickHandler(element);
            element.addEventListener("click", handler);
            // イベントリスナーを保存
            this.#eventListeners.set(element, { type: "click", handler });
        });
    }

    /**
     * すべてのイベントリスナーを削除する
     */
    static unmount() {
        // 通常のクリックイベントの削除
        this.#eventListeners.forEach((listener, element) => {
            if (element && element.removeEventListener) {
                element.removeEventListener(listener.type, listener.handler);
            }
        });
        this.#eventListeners.clear();

        // モーダル背景のイベントリスナーも削除
        const modalBackgrounds = document.querySelectorAll(".modalbg");
        modalBackgrounds.forEach((bg) => {
            const listener = this.#eventListeners.get(bg);
            if (listener) {
                bg.removeEventListener(listener.type, listener.handler);
            }
        });
    }

    /**
     * クリックハンドラーを作成する
     * @param {Element} element - クリックイベントを設定する要素
     * @returns {Function} クリックハンドラー関数
     */
    static #createClickHandler(element) {
        return (e) => {
            // data-only-me属性のチェックを追加
            const isOnlyMe = element.hasAttribute("data-only-me");

            // only-meが設定されていて、クリックされた要素が直接の対象でない場合は処理をスキップ
            if (isOnlyMe && e.target !== element) return;

            const isMyselfTarget = element.dataset.elm === "myself";

            if (isMyselfTarget) {
                if (e.target !== e.currentTarget) return;
                const isOn = !element.classList.contains("is-on");
                element.classList.toggle("is-on");

                // アクションクラスの処理
                const actionClasses = element.className
                    .split(" ")
                    .filter((className) =>
                        this.#actions.hasOwnProperty(className)
                    );

                actionClasses.forEach((actionClass) => {
                    this.#actions[actionClass](isOn, element);
                });
            } else {
                const targetElement = document.querySelector(
                    `#${element.dataset.elm}`
                );
                if (!targetElement) return;

                const isOn = !targetElement.classList.contains("is-on");
                targetElement.classList.toggle("is-on");

                // アクションクラスの処理
                const actionClasses = targetElement.className
                    .split(" ")
                    .filter((className) =>
                        this.#actions.hasOwnProperty(className)
                    );

                actionClasses.forEach((actionClass) => {
                    this.#actions[actionClass](isOn, targetElement);
                });
            }
        };
    }

    /**
     * モーダル背景のクリックイベントを設定する
     * @param {string} selector - モーダル背景要素のセレクター
     */
    static initModalBackground(selector = ".modalbg") {
        const modalBackgrounds = document.querySelectorAll(selector);
        modalBackgrounds.forEach((bg) => {
            const handler = (e) => {
                if (e.target !== e.currentTarget) return;

                const isOn = !bg.classList.contains("is-on");
                bg.classList.toggle("is-on");

                const actionClasses = bg.className
                    .split(" ")
                    .filter((className) =>
                        this.#actions.hasOwnProperty(className)
                    );

                actionClasses.forEach((actionClass) => {
                    this.#actions[actionClass](isOn, bg);
                });
            };

            bg.addEventListener("click", handler);
            // イベントリスナーを保存
            this.#eventListeners.set(bg, { type: "click", handler });
        });
    }
}

// 初期化
OnClickManager.init();
OnClickManager.initModalBackground();

// コンポーネントのアンマウント時に呼び出す
// OnClickManager.unmount();
